"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = series;
function series(reducer, initial) {
  return function (iterable) {
    return iterable.reduce(function (chain, value, key) {
      return chain.then(function (results) {
        return reducer(results, value, key, iterable);
      });
    }, Promise.resolve(initial));
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/awaity/esm/__internal__/series.js
// module id = 218
// module chunks = 0